/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BsTypeEnum {
    REALTIME = 'realtime',
    OVERALL = 'overall',
}